export default __webpack_public_path__ + "static/montserrat-a351aa11871cd23dc84b3c1b67e33f24.woff2";